<template>
  <unicom-layout-cartao semFiltro>
    <div>
      <unicom-linha class="pb-4">
        <unicom-coluna sm="12" md="auto">
          <div class="titulo negrito cor-fonte fonte-primaria">
            Contatos
            <button @click="show = !show" class="botao-abre-fecha">
              {{ show ? "-" : "+" }}
            </button>
          </div>
        </unicom-coluna>
        <unicom-coluna
          sm="12"
          md="auto"
          class="ml-auto"
          :class="$breakpoint.smAndDown ? 'mt-2' : ''"
          v-if="mostrarBotaoAdicionar"
        >
          <unicom-botao
            @click="$emit('adicionar-contato')"
            contornado
            :bloco="$breakpoint.smAndDown"
            :largura="220"
            nomeIcone="plus"
            >ADICIONAR CONTATO</unicom-botao
          >
        </unicom-coluna>
      </unicom-linha>
      <div class="body-tabela-erro" v-show="show">
        <unicom-tabela
          iconeMensagemVazia="users"
          :valoresSwitchProp="valoresSwitchData"
          mensagemVazia="Nenhum contato cadastrado"
          subtituloMensagemVazia="Adicionar contato"
          mostrarNovoBlocoVazio
          :alturaBody="196"
          :exibirBotaoPaginacao="false"
          :exibirTodosHeaders="false"
          :icones="[
            { nome: 'edit', tooltipNome: 'Editar contato' },
            { nome: 'clock', tooltipNome: 'Histórico' },
            { nome: 'trash-2', tooltipNome: 'Excluir contato' }
          ]"
          :itensPorPagina="['5', '10', '15', '20']"
          itemSelecionadoProp="10"
          :carregamento="loadingContatos"
          :pagina="pagina"
          :qtPaginas="qtPaginas"
          :qtResultados="rows.length"
          :rows="rows"
          :cabecalho="cabecalho"
          novaLinha
          alinharFooter="end"
          :exibirFooter="rows.length > 0"
          textoExibindo="registros"
          @click-subtitulo-mensagem="$emit('adicionar-contato')"
          @troca-pagina="trocarPagina"
          @input-switch="inputSwitch"
          @input-array-switch="inputArraySwitch"
          @acao="escolherAcao"
        />
      </div>
    </div>
  </unicom-layout-cartao>
</template>

<script>
import TabelaContatosMixin from "./TabelaContatosMixin";

export default {
  mixins: [TabelaContatosMixin],
  data() {
    return {
      show: false
    };
  }
};
</script>

<style scoped>
span {
  margin: 0.5rem;
}
.input-control {
  margin: 1rem 0;
}
.rotulos {
  margin-top: 1rem;
}
.rotulos p {
  font-size: 1rem;
}
.botao-abre-fecha {
  margin-left: auto;
  cursor: pointer;
  height: 2rem;
  font-size: 2rem;
  color: #00995d;
  background-color: white;
  font-weight: 400;
}
.linha {
  margin: 1rem;
}
.coluna {
  margin: 0;
  padding: 0;
}
.corpo {
  padding: 1rem;
}
.linha-embaixo-titulo {
  border-bottom: 2px solid #ebebeb;
}
</style>
